<template>
    <Transition name="noti">
        <NotificationCMS 
            v-if="trys < 4 && trys !== 0"
            :tekst="'U heeft nog ' + trys + ' poging(en) voor dit apparaat tijdelijk word geblokeerd.'"
            :icon="'alert'"
        />
    </Transition>
    <Transition name="noti">
        <NotificationCMS 
            v-if="trys == 0"
            :tekst="'Dit apparaat is tijdelijk geblokkeerd. Neem contact op met Devenox.'"
            :icon="'alert'"
        />
    </Transition>
    <div class="login">
    <div class="login__hero">

    </div>
    <div class="login__form" v-if="status.ipOk == true">
        <form action="">
            <div>
                <h1>{{ moment }}</h1>
                <p>Voer uw email en wachtwoord in om toegang te krijgen tot uw dashboard.</p>
            </div>
            <div class="form_control">
                <label :class="passClass" for="mail">Email</label>
                <div class="form_control_icon">
                    <div class="button_2 form_icon_left"><i class="fa-solid fa-envelope"></i></div>
                    <input :class="mailClass + 'input_icon_left'" type="mail" v-model="inputMail" @keyup.enter="processLogin">
                </div>
            </div>
            <div class="form_control">
                <label :class="passClass" for="password">Wachtwoord</label>
                <div class="form_control_icon">
                    <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                    <input class="input_icon_both" :type="pass" id="password" name="password" v-model="inputPass" @keyup.enter="processLogin">
                    <div class="button_2 form_icon_right" @click="showPass">
                        <i v-if="pass === 'password'" class="fa-solid fa-eye-slash"></i>
                        <i v-else class="fa-solid fa-eye"></i>
                    </div>
                </div>
            </div>
            <div class="form_control_dubbel">
                <div class="form_control_check" @click="clickRemember">
                    <i v-if="rememberMe" class="fa-solid fa-square-check form_checkbox" ></i>
                    <i v-else  class="fa-regular fa-square form_checkbox"></i>
<!--                     <input  type="checkbox" name="remember" id="remember" v-model="rememberMe" @keyup.enter="processLogin">-->
                    <p for="remember">Onthoud mij</p>
                </div>
                <a>Wachtwoord vergeten?</a>
            </div>
            <div>
                <p class="button" @click="processLogin" @keyup.enter="processLogin">Log in</p>
            </div>
        </form>
        <div class="login__form__version">
            <p class="nav__version">&copy; {{copy}}</p>
            <p class="nav__version">{{version}}</p>
        </div>
    </div>
    <div class="login__form login__blocked" v-if="status.ipOk == false">
        <form action="">
            <div>
                <h1>{{ moment }}</h1>
                <p>Voer uw email en wachtwoord in om toegang te krijgen tot uw dashboard.</p>
            </div>
            <div class="form_control">
                <label :class="passClass" for="mail">Email</label>
                <div class="form_control_icon">
                    <div class="button_2 form_icon_left"><i class="fa-solid fa-envelope"></i></div>
                    <input disabled :class="mailClass + 'input_icon_left'" type="mail" id="mail" name="mail" v-model="inputMail" @keyup.enter="processLogin">
                </div>
            </div>
            <div class="form_control">
                <label :class="passClass" for="password">Wachtwoord</label>
                <div class="form_control_icon">
                    <div class="button_2 form_icon_left"><i class="fa-solid fa-lock"></i></div>
                    <input disabled class="input_icon_both" :type="pass" id="password" name="password" v-model="inputPass" @keyup.enter="processLogin">
                    <div class="button_2 form_icon_right" @click="showPass">
                        <i v-if="pass === 'password'" class="fa-solid fa-eye-slash"></i>
                        <i v-else class="fa-solid fa-eye"></i>
                    </div>
                </div>
            </div>
            <div class="form_control_dubbel">
                <div class="form_control_check" @click="clickRemember">
                    <i v-if="rememberMe" class="fa-solid fa-square-check form_checkbox" ></i>
                    <i v-else  class="fa-regular fa-square form_checkbox"></i>
<!--                     <input  type="checkbox" name="remember" id="remember" v-model="rememberMe" @keyup.enter="processLogin">-->
                    <p for="remember">Onthoud mij</p>
                </div>
                <a>Wachtwoord vergeten?</a>
            </div>
            <div>
                <p class="button">Log in</p>
            </div>
        </form>
        <div class="login__form__version">
            <p class="nav__version">&copy; {{copy}}</p>
            <p class="nav__version">{{version}}</p>
        </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { sha512 } from 'js-sha512';
import NotificationCMS from '../components/NotificationCMS.vue';
export default {
    inject:['status', 'data'],
    components:{
        NotificationCMS
    },
    data(){
        return{
            inputMail: "",
            inputPass: "",
            rememberMe: false,
            mailClass: "",
            passClass: "",
            moment: "",
            pass: "password",
            copy: "",
            version: "",
            pogingen: 4,
            trys: 4,
            noti: {
                status: false,
                tekst: "",
                icon: ""
            }
        }
    },
    methods: {
        clickRemember(){
            if(this.rememberMe){
                this.rememberMe = false;
            } else{
                this.rememberMe = true;
            }
        },  
        showPass(){
            if(this.pass === "password"){
                this.pass = "text";
            } else {
                this.pass = "password"
            }
        },  
        async processLogin(){
            let data = {mail: 0, password: 0};
            await axios.get(this.status.api + '/get/login.php',{ 
                params:{ 
                    ip: this.status.userIp,
                    mail: this.inputMail, 
                    password: sha512(this.inputPass + this.status.salted),
                }
                }).then(function(response){
                    if(response.data.length === 1){
                        data = response.data[0];
                    }
                }).catch(function(error){ 
                    console.log(error);
                });
            if(data.mail === this.inputMail && data.password === sha512(this.inputPass + this.status.salted)){
                if(this.rememberMe){
                    localStorage.DevUser = true;
                    localStorage.DevUserMail = data.mail;
                    localStorage.DevUserPass = this.inputPass;
                } else{
                    sessionStorage.DevUser = true;
                    sessionStorage.DevUserMail = data.mail;
                    sessionStorage.DevUserPass = this.inputPass;
                }
                this.status.user = true;
                this.status.db = data.db;
                this.status.userId = data.id;
                this.status.userName = data.username;
                this.status.userCompany = data.company;
                this.status.userKey = sha512(data.user_key);
                if(data.img == ""){
                    this.status.userImage = "assets/user.png";
                } else {
                    this.status.userImage = data.img;
                }
                this.status.userPass = sha512(this.inputPass + this.status.salted);
                this.status.userMail = this.inputMail;
                this.$router.push('/');
            } else {
                this.passClass = "login-error"
                this.inputPass = "";
                this.ipCheck();
            }
        },
        async ipCheck(){
            let ipData;
            await axios.get(this.status.api + '/get/ip-checker.php',{ 
                }).then(function(response){
                    ipData = response.data;
                }).catch(function(error){ 
                    console.log(error);
                });
                let aantal = this.pogingen - ipData.length;
                this.trys = aantal;
            if(ipData.length > 3){
                this.status.ipOk = false;
            } else{
                this.status.ipOk = true;
                this.noti = {
                        status: false,
                }
            }
            this.status.ipOk = true;
        },
        async localStorageCheck(){
            let data = {mail: 0, password: 0};
            await axios.get(this.status.api + '/get/login.php',{ 
                params:{ 
                    mail: localStorage.DevUserMail, 
                    password: sha512(localStorage.DevUserPass + this.status.salted),
                }
                }).then(function(response){
                    if(response.data.length === 1){
                        data = response.data[0];
                    }
                    
                }).catch(function(error){ 
                    console.log(error);
                });
            if(localStorage.DevUserMail === data.mail && sha512(localStorage.DevUserPass + this.status.salted) === data.password){
                this.status.user = true;
                this.status.db = data.db;
                this.status.userId = data.id;
                this.status.userName = data.username;
                this.status.userCompany = data.company;
                this.status.userKey = sha512(data.user_key);
                if(data.img == ""){
                    this.status.userImage = "assets/user.png";
                } else {
                    this.status.userImage = data.img;
                }                this.status.userPass = sha512(localStorage.DevUserPass + this.status.salted);
                this.status.userMail = localStorage.DevUserMail;
                this.$router.push('/');
            }
        },
        async sessionStorageCheck(){
            let data = {mail: 0, password: 0};
            await axios.get(this.status.api + '/get/login.php',{ 
                params:{ 
                    mail: sessionStorage.DevUserMail, 
                    password: sha512(sessionStorage.DevUserPass + this.status.salted),
                }
                }).then(function(response){
                    if(response.data.length === 1){
                        data = response.data[0];
                    }
                    
                }).catch(function(error){ 
                    console.log(error);
                });
            if(sessionStorage.DevUserMail === data.mail && sha512(sessionStorage.DevUserPass + this.status.salted) === data.password){
                this.status.user = true;
                this.status.db = data.db;
                this.status.userId = data.id;
                this.status.userName = data.username;
                this.status.userCompany = data.company;
                this.status.userKey = sha512(data.user_key);
                if(data.img == ""){
                    this.status.userImage = "assets/user.png";
                } else {
                    this.status.userImage = data.img;
                }                this.status.userPass = sha512(sessionStorage.DevUserPass + this.status.salted);
                this.status.userMail = sessionStorage.DevUserMail;
                this.$router.push('/');
            }
        }
    },
    created(){

        if(localStorage.DevUser){
            this.localStorageCheck();
        } 
        if(sessionStorage.DevUser){
            this.sessionStorageCheck()
        }
        let date = new Date();
        let h = date.getHours();
        if(h >= 6 && h <= 11){
            this.moment = "Goedemorgen"
        } else if(h >= 12 && h <= 13){
            this.moment = "Goedemiddag"
        } else if(h >= 14 && h <= 16){
            this.moment = "Goededag"
        } else if(h >= 17 && h <= 21){
            this.moment = "Goedeavond";
        } else if(h >= 22){
            this.moment = "Goedenacht"
        }
        this.copy = "Devenox - " + date.getFullYear();
        this.version = "V" + this.status.version;
        this.ipCheck();
    }
}
</script>